{
    "title": "Welcome back!",
    "featureSectionTitle": "Here's what's new:",
    "readMore": {
        "fullText": "Read more about our latest updates",
        "linkText": "Read more",
        "url": "https://www.nutshell.com/product-updates"
    }
}
